webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    crearSolicitud: function crearSolicitud() {
      var solicitudApi = {
        tokenId: encodeURIComponent(localStorage.getItem('ventasTokenId')),
        local: localStorage.getItem('ventasLocal')
      };
      return solicitudApi;
    },
    formatoFecha: function formatoFecha(fecha) {
      if (!fecha) return null;

      var _fecha$split = fecha.split('-'),
          _fecha$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_fecha$split, 3),
          year = _fecha$split2[0],
          month = _fecha$split2[1],
          day = _fecha$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(fecha) {
      if (!fecha) return null;

      var _fecha$split3 = fecha.split('/'),
          _fecha$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_fecha$split3, 3),
          day = _fecha$split4[0],
          month = _fecha$split4[1],
          year = _fecha$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    }
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      versionCli: '1.0.36',
      versionSer: '',
      tokenId: '',
      login: false,
      loginForm: { open: false },
      loginMsg: '',
      cambiarClave: { open: false },
      drawer: null,
      entorno: '',
      menuSup: 'Ventas',
      itemsMenu: {
        Ventas: [{ icon: 'person', text: 'Clientes', url: '/clientes' }, { icon: 'store', text: 'Ventas', url: '/ventas' }, { icon: 'local_shipping', text: 'Guía de remisión', url: '/guias' }, { icon: 'shopping_cart', text: 'Compras', url: '/compras' }, { icon: 'account_balance', text: 'Depósitos', url: '/depositos' }, { icon: 'print', text: 'Reportes', url: '/reportes' }],
        Almacén: [{ icon: 'assignment', text: 'Catálogo', url: '/catalogo' }, { icon: 'add_circle', text: 'Ingresos', url: '/ingresos' }, { icon: 'remove_circle', text: 'Salidas', url: '/salidas' }]
      },
      ubigeo: [],
      locales: [],
      local: '',
      empresa: '',
      usuario: ''
    };
  },
  props: {
    source: String
  },
  beforeMount: function beforeMount() {
    this.entorno = "production";
    this.tokenId = localStorage.getItem('ventasTokenId');
    this.local = localStorage.getItem('ventasLocal');
    if (this.$router.currentRoute.name === 'Catalogo') {
      this.menuSup = 'Almacén';
    }
    this.variablesApp();
  },

  watch: {
    tokenId: function tokenId(val) {
      localStorage.setItem('ventasTokenId', val);
    },
    local: function local(val) {
      localStorage.setItem('ventasLocal', val);
      if (val === 'undefined') {
        localStorage.setItem('ventasLocal', '');
      }
    },
    login: function login(val) {
      if (val === false) {
        this.loginForm.open = true;
      }
    }
  },
  methods: {
    variablesApp: function variablesApp() {
      var solicitudApi = this.crearSolicitud();
      var vueThis = this;
      var myRequest = new Request("https://apik.canguapps.com/" + 'inicio/variablesApp', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      this.loading = true;
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          vueThis.loginOff(['']);
        } else {
          vueThis.login = datos.l;
          vueThis.versionSer = datos.d.version;
          vueThis.empresa = datos.d.empresa;
          vueThis.usuario = datos.d.usuario;
          vueThis.locales = datos.d.locales;
          vueThis.local = datos.d.local;
          vueThis.ubigeo = datos.d.ubigeo;
          localStorage.setItem('ventasVars', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(datos)));
        }
      }).catch(function () {
        var datos = JSON.parse(atob(localStorage.getItem('ventasVars')));
        if (datos.l === false) {
          vueThis.loginOff(['']);
        } else {
          vueThis.login = datos.l;
          vueThis.empresa = datos.d.empresa;
          vueThis.usuario = datos.d.usuario;
          vueThis.locales = datos.d.locales;
          vueThis.local = datos.d.local;
          vueThis.ubigeo = datos.d.ubigeo;
        }
      });
    },
    setToken: function setToken(token) {
      this.tokenId = token;
      this.login = true;
      localStorage.setItem('ventasTokenId', token);
      this.variablesApp();
    },
    setLocal: function setLocal(local) {
      for (var buscar in this.locales) {
        if (this.locales[buscar].nombre === local) {
          localStorage.setItem('ventasLocal', local);
          this.local = local;
          this.$router.push('/');
          this.variablesApp();
          return;
        }
      }
      localStorage.setItem('ventasLocal', this.local);
      this.$router.push('/');
    },
    loginOff: function loginOff(msg) {
      this.login = false;
      if (0 in msg) {
        this.loginMsg = msg[0];
      } else {
        this.loginMsg = msg;
      }
      this.loginForm.open = true;
    },
    cerrarSesion: function cerrarSesion() {
      localStorage.setItem('ventasTokenId', '');
      localStorage.setItem('ventasLocal', '');
      this.login = false;
    },
    seleccionarMenuSup: function seleccionarMenuSup(menu) {
      this.menuSup = menu;
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  prefix: '',
  thousands: '',
  decimal: '.',
  precision: 2
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inicio',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__ = __webpack_require__(52);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f84c3aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesLista_vue__ = __webpack_require__(245);
function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f84c3aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'clientes-lista',
  props: {
    ubigeo: {},
    seleccionar: false
  },
  data: function data() {
    return {
      ventanaRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      headers: [{ text: 'Razón social / Nombre', value: 1 }, { text: 'Dirección', value: 1 }, { text: 'Tipo de documento', value: 2 }, { text: 'Número de documento', value: 3 }, { text: 'Acciones', align: 'center', value: '', sortable: false }],
      datos: [],
      idClienteActual: ''
    };
  },
  watch: {
    ventanaRegistro: function ventanaRegistro() {
      if (this.ventanaRegistro === false) {
        this.idClienteActual = '';
      }
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      this.idClienteActual = item.id;
      this.ventanaRegistro = true;
    },
    nuevoRegistro: function nuevoRegistro() {
      this.idClienteActual = 0;
      this.ventanaRegistro = true;
    },
    cerrarRegistro: function cerrarRegistro() {
      this.ventanaRegistro = false;
    },
    listar: function listar() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },
    enviarRegistro: function enviarRegistro(item) {
      this.$emit('seleccionado', item);
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComprobantesLista_vue__ = __webpack_require__(54);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55af0f88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComprobantesLista_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComprobantesLista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55af0f88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComprobantesLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'comprobantes-lista',
  props: {
    ubigeo: {},
    idCliente: 0
  },
  data: function data() {
    return {
      ventanaRegistro: false,
      totalRegistros: 0,
      filtro: { serie: '', numero: '', estado: '*', reset: false },
      sinEmitir: 0,
      estadosComprobante: [{ id: '*', value: '--------------------' }],
      loading: false,
      pagination: { rowsPerPage: 10 },
      headers: [{
        text: 'Fecha',
        align: 'left',
        value: 0
      }, { text: 'Serie', value: 1 }, { text: 'Número', value: 2 }, { text: 'Monto', value: 3 }, { text: 'Estado', value: 4 }, { text: 'Acciones', align: 'center', value: '', sortable: false }],
      datos: [],
      idComprobanteActual: ''
    };
  },
  watch: {
    ventanaRegistro: function ventanaRegistro() {
      if (this.ventanaRegistro === false) {
        this.idComprobanteActual = '';
      }
    },
    idCliente: function idCliente() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        idCliente: 0,
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        filtro: this.filtro
      };
      solicitudApi.datos = datos;
      if (this.idCliente !== undefined) {
        solicitudApi.datos.idCliente = this.idCliente;
      }
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.sinEmitir = _this.datos.sinEmitir;
          _this.totalRegistros = _this.datos.registros;
          for (var estadoComprobante in _this.datos.estadosComprobante) {
            _this.estadosComprobante.push({ 'id': estadoComprobante, 'value': _this.datos.estadosComprobante[estadoComprobante] });
          }
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      this.idComprobanteActual = item.id;
      this.ventanaRegistro = true;
    },
    nuevoRegistro: function nuevoRegistro() {
      this.idComprobanteActual = 0;
      this.ventanaRegistro = true;
    },
    cerrarRegistro: function cerrarRegistro() {
      this.ventanaRegistro = false;
    },
    listarFiltro: function listarFiltro() {
      this.filtro.reset = true;
      this.listar();
      this.filtro.reset = false;
    },
    listar: function listar() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },
    imprimirRegistro: function imprimirRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.content !== undefined) {
          var win = window.open('', '_blank');
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js___default.a.pdfMake.vfs;
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.createPdf(dd).open({}, win);
        }
      });
    },
    descargarRegistro: function descargarRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.content !== undefined) {
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js___default.a.pdfMake.vfs;
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.createPdf(dd).download(item.fila[2] + '-' + item.fila[3]);
        }
      });
    }
  }
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledComprobante: false,
      totalComprobantes: 0,
      loading: false,
      pagination: {},
      menu: false,
      gastoFecha: null,
      headers: [{
        text: 'Fecha',
        align: 'left',
        value: 0
      }, { text: 'Serie', value: 1 }, { text: 'Número', value: 2 }, { text: 'Monto', value: 3 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      datos: [],
      tiposDocumentos: [{ id: '0', value: '' }, { id: '1', value: 'DNI' }, { id: '6', value: 'RUC' }, { id: '4', value: 'Carnet de extranjería' }, { id: '7', value: 'Pasaporte' }],
      comprobante: {},
      errores: {
        'gastoFecha': { mensajes: [], error: false },
        'gastoNumero': { mensajes: [], error: false },
        'gastoSerie': { mensajes: [], error: false },
        'gastoTotal': { mensajes: [], error: false }
      }
    };
  },
  computed: {
    computedGastoFecha: function computedGastoFecha() {
      return this.formatoFecha(this.comprobante.gastoFecha);
    },
    registroTotal: function registroTotal() {
      var total = 0;
      for (var detalle in this.comprobante.gastoDetalles) {
        total += parseFloat(this.comprobante.gastoDetalles[detalle].gastoMonto);
      }
      return total.toFixed(2);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'comprobante.gastoFecha': function comprobanteGastoFecha(val) {
      this.gastoFecha = this.formatoFecha(this.comprobante.gastoFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaComprobantes(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaComprobantes: function apiListaComprobantes(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      solicitudApi.datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      var myRequest = new Request("https://apik.canguapps.com/" + 'gasto/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalComprobantes = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verComprobante: function verComprobante(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://apik.canguapps.com/" + 'gasto/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.comprobante = datos.d.gasto;
          _this2.errores = datos.d.errores;
          if (item.id !== 0) {
            _this2.disabledComprobante = true;
          } else {
            _this2.disabledComprobante = false;
          }
          _this2.dialog = true;
        }
      });
    },
    nuevoComprobante: function nuevoComprobante() {
      this.verComprobante({ id: 0 });
    },
    detalleNuevo: function detalleNuevo() {
      var id = 0;
      while (id in this.comprobante.gastoDetalles) {
        id++;
      }
      this.comprobante.gastoDetalles[id] = { id: 0, gastoDescripcion: '', gastoMonto: '' };
      this.$forceUpdate();
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar(id) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.comprobante;
      var myRequest = new Request("https://apik.canguapps.com/" + 'gasto/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.verComprobante(datos.d);
            var descendente = 0;
            if (_this3.pagination.descending) {
              descendente = 1;
            }
            _this3.apiListaComprobantes(_this3.pagination.sortBy, descendente, _this3.pagination.page);
            _this3.cerrar();
          } else {
            _this3.errores = datos.d.errores;
          }
        }
      });
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      depositoFecha: null,
      headers: [{
        text: 'Fecha',
        align: 'left',
        value: 0
      }, { text: 'Número', value: 1 }, { text: 'Monto', value: 2 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {},
      errores: {
        'depositoFecha': { mensajes: [], error: false },
        'depositoNumero': { mensajes: [], error: false },
        'depositoMonto': { mensajes: [], error: false }
      }
    };
  },
  computed: {
    computedDepositoFecha: function computedDepositoFecha() {
      return this.formatoFecha(this.registro.depositoFecha);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.depositoFecha': function registroDepositoFecha(val) {
      this.depositoFecha = this.formatoFecha(this.registro.depositoFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://apik.canguapps.com/" + 'deposito/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.productos = _this.datos.productos;
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://apik.canguapps.com/" + 'deposito/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d.registro;
          _this2.errores = datos.d.errores;
          if (item.id !== 0) {
            _this2.disabledRegistro = true;
          } else {
            _this2.disabledRegistro = false;
          }
          _this2.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ id: 0 });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar(id) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'deposito/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.verRegistro(datos.d);
            var descendente = 0;
            if (_this3.pagination.descending) {
              descendente = 1;
            }
            _this3.apiListaRegistros(_this3.pagination.sortBy, descendente, _this3.pagination.page);
            _this3.cerrar();
          } else {
            _this3.errores = datos.d.errores;
          }
        }
      });
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menuFechaInicio: false,
      menuFechaFin: false,
      fechaInicio: null,
      fechaFin: null,
      datos: [],
      reportes: [{ id: 'C', value: 'Comprobantes' }],
      registro: {}
    };
  },
  computed: {
    computedFechaInicio: function computedFechaInicio() {
      return this.formatoFecha(this.registro.fechaInicio);
    },
    computedFechaFin: function computedFechaFin() {
      return this.formatoFecha(this.registro.fechaFin);
    }
  },
  watch: {
    'registro.fechaInicio': function registroFechaInicio(val) {
      this.fechaInicio = this.formatoFecha(this.registro.fechaInicio);
    },
    'registro.fechaFin': function registroFechaFin(val) {
      this.fechaFin = this.formatoFecha(this.registro.fechaFin);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    this.pagination.rowsPerPage = 10;
    this.nuevoRegistro();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    verRegistro: function verRegistro(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://apik.canguapps.com/" + 'ventasReportes/ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.registro = datos.d;
          if (item.id !== 0) {
            _this.disabledRegistro = true;
          } else {
            _this.disabledRegistro = false;
          }
          _this.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ id: 0 });
    },
    generar: function generar() {
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'ventasReportes/imprimir', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.d.tipo === 'xlsx') {
          var link = document.createElement('a');
          link.href = 'data:application/xlsx;base64,' + datos.d.data;
          link.download = datos.d.nombre;
          link.click();
        }
      });
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'catalogo-lista',
  props: {
    ubigeo: {},
    seleccionar: false
  },
  data: function data() {
    return {
      ventanaRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      headers: [{ text: 'Artículo', value: 1 }, { text: 'Unidad', value: 1 }, { text: 'Marca', value: 2 }, { text: 'Modelo', value: 3 }, { text: 'Acciones', align: 'center', value: '', sortable: false }],
      datos: [],
      idCatalogoActual: ''
    };
  },
  watch: {
    ventanaRegistro: function ventanaRegistro() {
      if (this.ventanaRegistro === false) {
        this.idCatalogoActual = '';
      }
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://apik.canguapps.com/" + 'catalogo/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      this.idCatalogoActual = item.id;
      this.ventanaRegistro = true;
    },
    nuevoRegistro: function nuevoRegistro() {
      this.idCatalogoActual = 0;
      this.ventanaRegistro = true;
    },
    cerrarRegistro: function cerrarRegistro() {
      this.ventanaRegistro = false;
    },
    listar: function listar() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },
    enviarRegistro: function enviarRegistro(item) {
      this.$emit('seleccionado', item);
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuiaRemisionLista_vue__ = __webpack_require__(62);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71527fa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuiaRemisionLista_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuiaRemisionLista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71527fa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuiaRemisionLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuiaRemision_vue__ = __webpack_require__(63);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'guia-remision-lista',
  components: {
    GuiaRemision: __WEBPACK_IMPORTED_MODULE_2__GuiaRemision_vue__["default"]
  },
  props: {
    ubigeo: {},
    idCliente: 0
  },
  data: function data() {
    return {
      ventanaRegistro: false,
      totalRegistros: 0,
      filtro: { serie: '', numero: '', estado: '*', reset: false },
      sinEmitir: 0,
      estadosGuia: [{ id: '*', value: '--------------------' }],
      loading: false,
      pagination: { rowsPerPage: 10 },
      headers: [{
        text: 'Fecha',
        align: 'left',
        value: 0
      }, { text: 'Serie', value: 1 }, { text: 'Número', value: 2 }, { text: 'Estado', value: 3 }, { text: 'Acciones', align: 'center', value: '', sortable: false }],
      datos: [],
      idGuiaActual: ''
    };
  },
  watch: {
    ventanaRegistro: function ventanaRegistro() {
      if (this.ventanaRegistro === false) {
        this.idGuiaActual = '';
      }
    },
    idCliente: function idCliente() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        idCliente: 0,
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        filtro: this.filtro
      };
      solicitudApi.datos = datos;
      if (this.idCliente !== undefined) {
        solicitudApi.datos.idCliente = this.idCliente;
      }
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.sinEmitir = _this.datos.sinEmitir;
          _this.totalRegistros = _this.datos.registros;
          for (var estadoGuia in _this.datos.estadosGuia) {
            _this.estadosGuia.push({ 'id': estadoGuia, 'value': _this.datos.estadosGuia[estadoGuia] });
          }
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      this.idGuiaActual = item.id;
      this.ventanaRegistro = true;
    },
    nuevoRegistro: function nuevoRegistro() {
      this.idGuiaActual = 0;
      this.ventanaRegistro = true;
    },
    cerrarRegistro: function cerrarRegistro() {
      this.ventanaRegistro = false;
    },
    listarFiltro: function listarFiltro() {
      this.filtro.reset = true;
      this.listar();
      this.filtro.reset = false;
    },
    listar: function listar() {
      if (this.loading === false) {
        var descendente = 0;
        if (this.pagination.descending) {
          descendente = 1;
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
      }
    },
    imprimirRegistro: function imprimirRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.pdfUrl !== undefined) {
          var win = window.open(dd.pdfUrl, '_blank');
          win.focus();
        }
      });
    },
    descargarRegistro: function descargarRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.pdfUrl !== undefined) {
          var win = window.open(dd.pdfUrl, '_blank');
          win.focus();
        }
      });
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuiaRemision_vue__ = __webpack_require__(64);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209259ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuiaRemision_vue__ = __webpack_require__(283);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuiaRemision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209259ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuiaRemision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */]],
  name: 'guia-remision',
  props: {
    idRegistro: 0,
    ubigeo: {},
    idCliente: 0
  },
  data: function data() {
    return {
      disabledRegistro: false,
      anularRegistro: false,
      loading: false,
      datos: [],
      tiposDocumentos: [{ id: '6', value: 'RUC' }],
      modalidadesTraslado: [{ id: '02', value: 'Privado' }],
      indicadoresTransbordo: [{ id: 'N', value: 'No' }],
      indicadoresVehiculo: [{ id: 'S', value: 'Si' }],
      registro: {},
      errores: {
        'comprobanteCliente': { mensajes: [], error: false },
        'comprobanteFecha': { mensajes: [], error: false },
        'comprobanteHora': { mensajes: [], error: false },
        'comprobanteNumero': { mensajes: [], error: false },
        'comprobanteSerie': { mensajes: [], error: false },
        'placaVehiculo': { mensajes: [], error: false }
      },
      menu: false,
      productos: {},
      productosCodigos: {},
      productosDetalle: {},
      comprobanteFecha: null,
      series: {},
      seriesCombo: [],
      ventanaCliente: false,
      seleccionarClienteActivo: true
    };
  },
  created: function created() {
    this.initialize();
  },

  computed: {
    computedComprobanteFecha: function computedComprobanteFecha() {
      return this.formatoFecha(this.registro.comprobanteFecha);
    },
    puedeAnular: function puedeAnular() {
      if (this.registro.comprobanteEstado === '') return false;
      if (this.registro.comprobanteEstado === '2') return false;
      if (this.registro.comprobanteEstado === '3') return false;
      if (this.registro.comprobanteEstado === '4') return false;
      var hoy = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      if (hoy.diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.registro.comprobanteFecha), 'days') > 7) return false;
      return true;
    },
    diasEmision: function diasEmision() {
      var hoy = new Date();
      var emision = new Date(this.registro.comprobanteFecha);
      var diffTime = Math.abs(hoy - emision);
      var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    colorEmitir: function colorEmitir() {
      if (this.diasEmision > 7) return 'error';
      return 'success';
    }
  },
  watch: {
    idRegistro: function idRegistro() {
      if (this.idRegistro !== '') {
        this.ver({ id: this.idRegistro });
      }
    },
    ventanaRegistroCliente: function ventanaRegistroCliente() {
      if (this.ventanaRegistroCliente === false) {
        this.idClienteActual = '';
      }
    },
    'registro.comprobanteFecha': function registroComprobanteFecha(val) {
      this.comprobanteFecha = this.formatoFecha(this.registro.comprobanteFecha);
    },
    'registro.comprobanteSerie': function registroComprobanteSerie(val) {
      if (!this.disabledRegistro) {
        this.registro.comprobanteNumero = this.series[this.registro.comprobanteSerie].ultimo;
      }
    }
  },
  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    ver: function ver(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { idCliente: this.idCliente };
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.anularRegistro = false;
          _this.registro = datos.d.comprobante;
          if (_this.registro.comprobanteDetalles && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this.registro.comprobanteDetalles) === 'object' && !Array.isArray(_this.registro.comprobanteDetalles)) {
            var detallesArray = [];
            for (var key in _this.registro.comprobanteDetalles) {
              detallesArray.push(_this.registro.comprobanteDetalles[key]);
            }
            _this.registro.comprobanteDetalles = detallesArray;
          } else if (!_this.registro.comprobanteDetalles) {
            _this.registro.comprobanteDetalles = [];
          }
          _this.seleccionarClienteActivo = false;
          if (datos.d.comprobante.comprobanteUbigeo === '') {
            _this.seleccionarClienteActivo = true;
          }
          _this.series = datos.d.series;
          _this.seriesCombo = [];
          var tipoComprobante = '09';
          if (item.id > 0) {
            tipoComprobante = _this.series[_this.registro.comprobanteSerie].tipo_comprobante;
          }
          for (var serie in _this.series) {
            if (tipoComprobante === _this.series[serie].tipo_comprobante) {
              _this.seriesCombo.push({ id: _this.series[serie].id, value: _this.series[serie].value });
            }
          }
          _this.productosCodigos = [];
          _this.productos = datos.d.productos;
          for (var producto in _this.productos) {
            _this.productosCodigos.push({ id: producto, nombre: _this.productos[producto].codigo + ' - ' + _this.productos[producto].nombre + ' (' + _this.productos[producto].unidadMedida + ')' });
          }
          _this.errores = datos.d.errores;
          if (item.id === 0) {
            _this.registro.comprobanteId = 0;
            _this.disabledRegistro = false;
          } else {
            _this.disabledRegistro = true;
          }
        }
      });
    },
    guardar: function guardar(id) {
      var _this2 = this;

      if (!this.registro.placaVehiculo) {
        this.errores.placaVehiculo = { mensajes: ['La placa de vehículo es obligatoria.'], error: true };
        return;
      }
      var solicitudApi = this.crearSolicitud();
      var registroParaBackend = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.registro);
      if (Array.isArray(registroParaBackend.comprobanteDetalles)) {
        var detallesObjeto = {};
        registroParaBackend.comprobanteDetalles.forEach(function (detalle, index) {
          detallesObjeto[index] = detalle;
        });
        registroParaBackend.comprobanteDetalles = detallesObjeto;
      }
      solicitudApi.datos = registroParaBackend;
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.ver(datos.d);
            _this2.$emit('listar');
          } else {
            _this2.errores = datos.d.errores;
          }
        }
      });
    },
    emitir: function emitir(id) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/emitir/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.ver(datos.d);
            _this3.$emit('listar');
          } else {
            alert(datos.m[0]);
          }
        }
      });
    },
    editar: function editar() {
      this.disabledRegistro = false;
    },
    confirmarAnular: function confirmarAnular() {
      this.anularRegistro = true;
    },
    cerrar: function cerrar() {
      this.$emit('cerrar');
    },
    detalleNuevo: function detalleNuevo() {
      this.registro.comprobanteDetalles.push({ id: 0, cantidad: 1, producto: '', descripcion: '', unidadMedida: '' });
    },

    escogerProducto: function escogerProducto(item) {
      if (!this.disabledRegistro) {
        item.cantidad = 1;
        item.descripcion = this.productos[item.producto].nombre;
        item.unidadMedida = this.productos[item.producto].unidadMedida;
      }
    },
    buscarCliente: function buscarCliente() {
      this.ventanaCliente = true;
    },
    seleccionarCliente: function seleccionarCliente(item) {
      this.registro.comprobanteClienteId = item.fila[0];
      this.registro.comprobanteCliente = item.fila[1];
      this.registro.comprobanteDireccion = item.fila[2];
      this.registro.comprobanteTipoDocumento = item.fila[6];
      this.registro.comprobanteNumeroDocumento = item.fila[4];
      this.registro.comprobanteUbigeo = item.fila[5];
      this.ventanaCliente = false;
    },
    anular: function anular(id) {
      var _this4 = this;

      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/anular/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.$emit('listar');
            _this4.cerrar();
          } else {
            alert(datos.m[0]);
          }
        }
      });
    },
    consultarRuc: function consultarRuc() {
      var _this5 = this;

      if (this.registro.comprobanteTipoDocumento !== '6' || this.registro.comprobanteClienteId !== undefined || this.registro.comprobanteNumeroDocumento.length !== 11) {
        return;
      }
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/datosRuc/' + this.registro.comprobanteNumeroDocumento, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this5.registro.comprobanteCliente = datos.d.data.razon;
            _this5.registro.comprobanteDireccion = datos.d.data.nombreVia;
          } else {
            _this5.registro.comprobanteCliente = '';
            _this5.registro.comprobanteDireccion = '';
          }
        }
      });
    },
    imprimirRegistro: function imprimirRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.pdfUrl !== undefined) {
          var win = window.open(dd.pdfUrl, '_blank');
          win.focus();
        }
      });
    }
  }
});

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  props: ['login', 'msgError'],
  data: function data() {
    return {
      usuario: '',
      clave: '',
      mensaje: ''
    };
  },
  methods: {
    cambiarMensaje: function cambiarMensaje(mensaje) {
      this.mensaje = mensaje;
    },
    cerrarVentana: function cerrarVentana() {
      this.login.open = false;
    },
    loginIngresar: function loginIngresar() {
      var _this = this;

      var myRequest = new Request('' + "https://apik.canguapps.com/login/", { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ usuario: this.usuario, clave: this.clave }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.cambiarMensaje(datos.m);
        } else {
          _this.cerrarVentana();
          _this.$emit('set-token', datos.d);
        }
      });
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cambiar-clave',
  props: ['cambiarClave'],
  methods: {
    cambiarClaveForm: function cambiarClaveForm(event) {
      self.cambiarClave = true;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'venta-producto',
  props: {
    producto: {
      nombre: '',
      precio: 0,
      cantidad: 0,
      total: 0,
      urlImg: ''
    },
    disabled: false
  },
  data: function data() {
    return {
      actualizarComputed: 0
    };
  },
  filters: {
    formatoNumero: function formatoNumero(value) {
      return new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }
  },
  computed: {
    colorFondo: function colorFondo() {
      this.actualizarComputed = 0;
      return this.producto.cantidad + this.actualizarComputed > 0 ? 'primary' : '';
    },
    colorTexto: function colorTexto() {
      this.actualizarComputed = 0;
      return this.producto.cantidad + this.actualizarComputed > 0 ? 'white' : '';
    },
    total: function total() {
      this.actualizarComputed = 0;
      return this.producto.cantidad + this.actualizarComputed > 0 ? this.producto.total : this.producto.precio;
    }
  },
  methods: {
    cambiarCantidad: function cambiarCantidad(diferencia) {
      if (!this.disabled && this.producto.cantidad + diferencia >= 0) {
        this.producto.cantidad += diferencia;
        this.producto.total = this.producto.cantidad * this.producto.precio;
        this.actualizarComputed = 1;
        this.$forceUpdate();
        this.$emit('cambio-total');
      }
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'venta-seleccionar-producto',
  props: {
    productos: {
      1: {
        nombre: '',
        precio: 0,
        cantidad: 0,
        total: 0,
        urlImg: ''
      }
    },
    disabled: false
  },
  methods: {
    calcularTotal: function calcularTotal() {
      var total = 0;
      for (var idDetalle in this.productos) {
        total += this.productos[idDetalle].total;
      }
      this.$emit('total-seleccion', total);
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'venta-manual',
  props: {
    productos: {
      1: {
        nombre: '',
        precio: 0,
        cantidad: 0,
        total: 0,
        urlImg: ''
      }
    },
    disabled: false
  },
  methods: {
    calcularTotal: function calcularTotal() {
      var total = 0;
      for (var idDetalle in this.productos) {
        total += this.productos[idDetalle].total;
      }
      this.$emit('total-seleccion', total);
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'cliente',
  props: {
    idRegistro: 0,
    ubigeo: {}
  },
  data: function data() {
    return {
      disabledRegistro: false,
      eliminarRegistro: false,
      loading: false,
      datos: [],
      tiposDocumentos: [{ id: '-', value: '-- Sin documento --' }, { id: '1', value: 'DNI' }, { id: '6', value: 'RUC' }, { id: '4', value: 'Carnet de extranjería' }, { id: '7', value: 'Pasaporte' }],
      registro: {},
      errores: {
        'clienteRazonSocial': { mensajes: [], error: false },
        'clienteDireccion': { mensajes: [], error: false },
        'clienteTipoDocumento': { mensajes: [], error: false },
        'clienteNumeroDocumento': { mensajes: [], error: false },
        'clienteUbigeo': { mensajes: [], error: false }
      }
    };
  },
  created: function created() {
    this.initialize();
  },

  watch: {
    idRegistro: function idRegistro() {
      if (this.idRegistro !== '') {
        this.ver({ id: this.idRegistro });
      }
    }
  },
  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    ver: function ver(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.registro = datos.d.cliente;
          _this.errores = datos.d.errores;
          _this.eliminarRegistro = false;
          if (item.id === 0) {
            _this.registro.clienteId = 0;
            _this.registro.clienteTipoDocumento = '-';
            _this.disabledRegistro = false;
          } else {
            _this.disabledRegistro = true;
          }
        }
      });
    },
    guardar: function guardar(id) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.ver(datos.d);
            _this2.$emit('listar');
          } else {
            _this2.errores = datos.d.errores;
          }
        }
      });
    },
    editar: function editar() {
      this.disabledRegistro = false;
    },
    cerrar: function cerrar() {
      this.$emit('cerrar');
    },
    confirmarEliminar: function confirmarEliminar() {
      this.eliminarRegistro = true;
    },
    cancelar: function cancelar() {
      this.eliminarRegistro = false;
    },
    borrar: function borrar(id) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/borrar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.$emit('listar');
            _this3.cerrar();
          } else {
            _this3.errores = datos.d.errores;
          }
        }
      });
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'comprobante',
  props: {
    idRegistro: 0,
    ubigeo: {},
    idCliente: 0
  },
  data: function data() {
    return {
      disabledRegistro: false,
      anularRegistro: false,
      loading: false,
      datos: [],
      tiposDocumentos: [{ id: '-', value: '' }, { id: '1', value: 'DNI' }, { id: '6', value: 'RUC' }, { id: '4', value: 'Carnet de extranjería' }, { id: '7', value: 'Pasaporte' }],
      registro: {},
      errores: {
        'comprobanteCliente': { mensajes: [], error: false },
        'comprobanteFecha': { mensajes: [], error: false },
        'comprobanteHora': { mensajes: [], error: false },
        'comprobanteNumero': { mensajes: [], error: false },
        'comprobanteSerie': { mensajes: [], error: false },
        'comprobanteTotal': { mensajes: [], error: false },
        'guiaSerie': { mensajes: [], error: false },
        'guiaNumero': { mensajes: [], error: false }
      },
      menu: false,
      productos: {},
      productosCodigos: {},
      productosDetalle: {},
      comprobanteFecha: null,
      series: {},
      seriesCombo: [],
      ventanaCliente: false,
      seleccionarClienteActivo: true
    };
  },
  created: function created() {
    this.initialize();
  },

  computed: {
    computedComprobanteFecha: function computedComprobanteFecha() {
      return this.formatoFecha(this.registro.comprobanteFecha);
    },
    puedeAnular: function puedeAnular() {
      if (this.registro.comprobanteEstado === '') return false;
      if (this.registro.comprobanteEstado === '2') return false;
      if (this.registro.comprobanteEstado === '3') return false;
      if (this.registro.comprobanteEstado === '4') return false;
      var hoy = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      if (hoy.diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.registro.comprobanteFecha), 'days') > 7) return false;
      return true;
    },
    diasEmision: function diasEmision() {
      var hoy = new Date();
      var emision = new Date(this.registro.comprobanteFecha);
      var diffTime = Math.abs(hoy - emision);
      var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    colorEmitir: function colorEmitir() {
      if (this.diasEmision > 7) return 'error';
      return 'success';
    }
  },
  watch: {
    idRegistro: function idRegistro() {
      if (this.idRegistro !== '') {
        this.ver({ id: this.idRegistro });
      }
    },
    ventanaRegistroCliente: function ventanaRegistroCliente() {
      if (this.ventanaRegistroCliente === false) {
        this.idClienteActual = '';
      }
    },
    'registro.comprobanteFecha': function registroComprobanteFecha(val) {
      this.comprobanteFecha = this.formatoFecha(this.registro.comprobanteFecha);
    },
    'registro.comprobanteSerie': function registroComprobanteSerie(val) {
      if (!this.disabledRegistro) {
        this.registro.comprobanteNumero = this.series[this.registro.comprobanteSerie].ultimo;
      }
    }
  },
  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    ver: function ver(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { idCliente: this.idCliente };
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.anularRegistro = false;
          _this.registro = datos.d.comprobante;
          _this.seleccionarClienteActivo = false;
          if (datos.d.comprobante.comprobanteUbigeo === '') {
            _this.seleccionarClienteActivo = true;
          }
          _this.series = datos.d.series;
          _this.seriesCombo = [];
          var tipoComprobante = '01';
          if (item.id > 0) {
            tipoComprobante = _this.series[_this.registro.comprobanteSerie].tipo_comprobante;
          }
          for (var serie in _this.series) {
            if (tipoComprobante === _this.series[serie].tipo_comprobante || (tipoComprobante === '01' || tipoComprobante === '03') && (_this.series[serie].tipo_comprobante === '01' || _this.series[serie].tipo_comprobante === '03')) {
              _this.seriesCombo.push({ id: _this.series[serie].id, value: _this.series[serie].value });
            }
          }
          _this.productosCodigos = [];
          _this.productos = datos.d.productos;
          for (var producto in _this.productos) {
            _this.productosCodigos.push({ id: producto, nombre: _this.productos[producto].codigo + ' - ' + _this.productos[producto].nombre + ' (' + _this.productos[producto].unidadMedida + ')' });
          }
          _this.errores = datos.d.errores;
          if (item.id === 0) {
            _this.registro.comprobanteId = 0;
            _this.disabledRegistro = false;
          } else {
            _this.disabledRegistro = true;
          }
        }
      });
    },
    guardar: function guardar(id) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.ver(datos.d);
            _this2.$emit('listar');
          } else {
            _this2.errores = datos.d.errores;
          }
        }
      });
    },
    emitir: function emitir(id) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/emitir/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.ver(datos.d);
            _this3.$emit('listar');
          } else {
            alert(datos.m[0]);
          }
        }
      });
    },
    editar: function editar() {
      this.disabledRegistro = false;
    },
    confirmarAnular: function confirmarAnular() {
      this.anularRegistro = true;
    },
    cerrar: function cerrar() {
      this.$emit('cerrar');
    },
    detalleNuevo: function detalleNuevo() {
      var id = 0;
      while (id in this.registro.comprobanteDetalles) {
        id++;
      }
      this.registro.comprobanteDetalles[id] = { id: 0, cantidad: 1, producto: '', descripcion: '', unidadMedida: '', total: '0.00', totalUnitario: '0.00' };
      this.$forceUpdate();
    },

    sumarTotal: function sumarTotal() {
      var total = 0.0;
      for (var detalle in this.registro.comprobanteDetalles) {
        this.registro.comprobanteDetalles[detalle].total = parseFloat(this.registro.comprobanteDetalles[detalle].totalUnitario * this.registro.comprobanteDetalles[detalle].cantidad).toFixed(2);
        total += parseFloat(this.registro.comprobanteDetalles[detalle].total);
      }
      this.registro.comprobanteTotal = total.toFixed(2);
    },
    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total.toFixed(2);
    },
    escogerProducto: function escogerProducto(item) {
      if (!this.disabledRegistro) {
        item.cantidad = 1;
        item.descripcion = this.productos[item.producto].nombre;
        item.unidadMedida = this.productos[item.producto].unidadMedida;
        item.totalUnitario = this.productos[item.producto].precio;
        item.total = this.productos[item.producto].precio;
        this.sumarTotal();
      }
    },
    buscarCliente: function buscarCliente() {
      this.ventanaCliente = true;
    },
    seleccionarCliente: function seleccionarCliente(item) {
      this.registro.comprobanteClienteId = item.fila[0];
      this.registro.comprobanteCliente = item.fila[1];
      this.registro.comprobanteDireccion = item.fila[2];
      this.registro.comprobanteTipoDocumento = item.fila[6];
      this.registro.comprobanteNumeroDocumento = item.fila[4];
      this.registro.comprobanteUbigeo = item.fila[5];
      this.consultarLeyAmazonia(item.fila[5]);
      this.ventanaCliente = false;
    },
    anular: function anular(id) {
      var _this4 = this;

      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/anular/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.$emit('listar');
            _this4.cerrar();
          } else {
            alert(datos.m[0]);
          }
        }
      });
    },
    consultarLeyAmazonia: function consultarLeyAmazonia(ubigeo) {
      var _this5 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/leyAmazonia/ubigeo/' + ubigeo, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this5.registro.bienesAmazonia = datos.d.bienesAmazonia;
            _this5.registro.serviciosAmazonia = datos.d.serviciosAmazonia;
          } else {
            alert(datos.m[0]);
          }
        }
      });
    },
    consultarDni: function consultarDni() {
      var _this6 = this;

      if (this.registro.comprobanteTipoDocumento !== '1' || this.registro.comprobanteClienteId !== undefined || this.registro.comprobanteNumeroDocumento.length !== 8) {
        return;
      }
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'cliente/datosDni/' + this.registro.comprobanteNumeroDocumento, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this6.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this6.registro.comprobanteCliente = datos.d.data.primerApellido + ' ' + datos.d.data.segundoApellido + ', ' + datos.d.data.nombres;
          } else {
            _this6.registro.comprobanteCliente = '';
          }
        }
      });
    },
    importarGuia: function importarGuia() {
      var _this7 = this;

      if (!this.registro.guiaSerie || !this.registro.guiaNumero) {
        alert('Debe ingresar la serie y número de guía');
        return;
      }
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'guia/ver/serie/' + this.registro.guiaSerie + '/numero/' + this.registro.guiaNumero, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this7.$emit('login', datos.m);
        } else if (datos.e === 1) {
          // Importar datos de la guía al comprobante
          var guia = datos.d.comprobante;
          _this7.registro.comprobanteClienteId = guia.comprobanteClienteId;
          _this7.registro.comprobanteCliente = guia.comprobanteCliente;
          _this7.registro.comprobanteDireccion = guia.comprobanteDireccion;
          _this7.registro.comprobanteTipoDocumento = guia.comprobanteTipoDocumento;
          _this7.registro.comprobanteNumeroDocumento = guia.comprobanteNumeroDocumento;
          _this7.registro.comprobanteUbigeo = guia.comprobanteUbigeo;

          // Importar detalles de productos
          _this7.registro.comprobanteDetalles = {};
          for (var id in guia.comprobanteDetalles) {
            var detalleGuia = guia.comprobanteDetalles[id];
            _this7.registro.comprobanteDetalles[id] = {
              id: 0,
              cantidad: detalleGuia.cantidad,
              producto: detalleGuia.producto,
              descripcion: detalleGuia.descripcion,
              unidadMedida: detalleGuia.unidadMedida,
              total: '0.00',
              totalUnitario: _this7.productos[detalleGuia.producto] ? _this7.productos[detalleGuia.producto].precio : '0.00'
            };
          }
          _this7.sumarTotal();
          _this7.consultarLeyAmazonia(guia.comprobanteUbigeo);
        } else {
          alert('No se encontró la guía de remisión');
        }
      });
    },
    imprimirRegistro: function imprimirRegistro(item) {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://apik.canguapps.com/" + 'comprobante/imprimir/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (dd) {
        if (dd.content !== undefined) {
          var win = window.open('', '_blank');
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts_js___default.a.pdfMake.vfs;
          __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default.a.createPdf(dd).open({}, win);
        }
      });
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  name: 'catalogo',
  props: {
    idRegistro: 0,
    ubigeo: {}
  },
  data: function data() {
    return {
      disabledRegistro: false,
      loading: false,
      datos: [],
      registro: {},
      errores: {
        'catalogoArticulo': { mensajes: [], error: false },
        'catalogoUnidad': { mensajes: [], error: false },
        'catalogoModelo': { mensajes: [], error: false },
        'catalogoMarca': { mensajes: [], error: false }
      }
    };
  },
  created: function created() {
    this.initialize();
  },

  watch: {
    idRegistro: function idRegistro() {
      if (this.idRegistro !== '') {
        this.ver({ id: this.idRegistro });
      }
    }
  },
  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    ver: function ver(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://apik.canguapps.com/" + 'catalogo/ver/id/' + item.id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.registro = datos.d.catalogo;
          _this.errores = datos.d.errores;
          if (item.id === 0) {
            _this.registro.catalogoId = 0;
            _this.disabledRegistro = false;
          } else {
            _this.disabledRegistro = true;
          }
        }
      });
    },
    guardar: function guardar(id) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://apik.canguapps.com/" + 'catalogo/guardar/id/' + id, { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.ver(datos.d);
            _this2.$emit('listar');
          } else {
            _this2.errores = datos.d.errores;
          }
        }
      });
    },
    editar: function editar() {
      this.disabledRegistro = false;
    },
    cerrar: function cerrar() {
      this.$emit('cerrar');
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(229);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b73a739_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(228);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b73a739_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"khimza"}},[(_vm.login)?_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.itemsMenu[_vm.menuSup]),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{key:("item-" + (item.text)),attrs:{"to":item.url}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1)]})],2)],1):_vm._e(),_vm._v(" "),(_vm.login)?_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"blue darken-3","dark":"","app":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0",staticStyle:{"width":"300px"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.empresa))])],1),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":"","disabled":_vm.menuSup === 'Ventas'},on:{"click":function($event){return _vm.seleccionarMenuSup('Ventas')}}},[_vm._v("Ventas")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.menuSup === 'Almacén'},on:{"click":function($event){return _vm.seleccionarMenuSup('Almacén')}}},[_vm._v("Almacén")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("notifications")])],1),_vm._v(" "),_c('div',{staticClass:"v-toolbar__items"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"v-btn--flat",attrs:{"slot":"activator"},slot:"activator"},[_c('span',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.local))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.locales),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.setLocal(item.nombre)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.nombre))])],1)}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"v-toolbar__items"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"v-btn--flat",attrs:{"slot":"activator"},slot:"activator"},[_c('span',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.usuario))])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.cambiarClave.open = true}}},[_c('v-list-tile-title',[_vm._v("Cambiar clave")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.cerrarSesion()}}},[_c('v-list-tile-title',[_vm._v("Cerrar sesión")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.login)?_c('v-content',[(_vm.versionCli !== _vm.versionSer)?_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("Hay una nueva versión disponible. Presione F5 para actualizar.")]):_vm._e(),_vm._v(" "),(_vm.entorno === 'development')?_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("Entorno de desarrollo")]):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('main',[_c('router-view',{attrs:{"ubigeo":_vm.ubigeo},on:{"login":_vm.loginOff}})],1)])],1)],1):_vm._e(),_vm._v(" "),_c('cambiar-clave',{attrs:{"cambiarClave":_vm.cambiarClave}}),_vm._v(" "),_c('login',{attrs:{"login":_vm.loginForm,"msgError":this.loginMsg},on:{"set-token":_vm.setToken}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_v_money__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inicio__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ClientesLista__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ComprobantesLista__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Compras__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Depositos__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ReporteVentas__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CatalogoLista__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GuiaRemisionLista__ = __webpack_require__(61);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('login', __webpack_require__(285).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('cambiar-clave', __webpack_require__(287).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('venta-producto', __webpack_require__(289).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('venta-seleccionar-producto', __webpack_require__(292).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('venta-manual', __webpack_require__(294).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('cliente', __webpack_require__(296).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('clientes-lista', __webpack_require__(51).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('comprobante', __webpack_require__(299).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('comprobantes-lista', __webpack_require__(53).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('catalogo', __webpack_require__(302).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('guia-remision', __webpack_require__(63).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('guia-remision-lista', __webpack_require__(61).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__lib_v_money__["a" /* default */]);

if (localStorage.getItem('ventasTokenId') === null) {
  localStorage.setItem('ventasTokenId', '');
}
if (localStorage.getItem('ventasLocal') === null) {
  localStorage.setItem('ventasLocal', '');
}
if (localStorage.getItem('ventasVars') === null) {
  localStorage.setItem('ventasVars', '');
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Inicio__["a" /* default */]
  }, {
    path: '/clientes',
    name: 'Clientes',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ClientesLista__["default"]
  }, {
    path: '/ventas',
    name: 'Ventas',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ComprobantesLista__["default"]
  }, {
    path: '/compras',
    name: 'Compras',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Compras__["a" /* default */]
  }, {
    path: '/depositos',
    name: 'Depositos',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Depositos__["a" /* default */]
  }, {
    path: '/reportes',
    name: 'ReporteVentas',
    component: __WEBPACK_IMPORTED_MODULE_11__components_ReporteVentas__["a" /* default */]
  }, {
    path: '/catalogo',
    name: 'Catalogo',
    component: __WEBPACK_IMPORTED_MODULE_12__components_CatalogoLista__["a" /* default */]
  }, {
    path: '/guias',
    name: 'GuiasRemision',
    component: __WEBPACK_IMPORTED_MODULE_13__components_GuiaRemisionLista__["default"]
  }]
}));

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directive__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(49);
/* unused harmony reexport VMoney */
/* unused harmony reexport options */






function install(Vue, globalOptions) {
  if (globalOptions) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(globalOptions).forEach(function (key) {
      __WEBPACK_IMPORTED_MODULE_2__options__["a" /* default */][key] = globalOptions[key];
    });
  }

  Vue.directive('money', __WEBPACK_IMPORTED_MODULE_1__directive__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (install);

// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(49);



function run(el, eventName) {
  var positionFromEnd = el.value.length - el.selectionEnd;
  el.value = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* format */])(el.value, __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */]);
  positionFromEnd = el.value.length - positionFromEnd;
  positionFromEnd = Math.max(positionFromEnd, __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].prefix.length + 1); // left
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* setCursor */])(el, positionFromEnd);
  el.dispatchEvent(new Event(eventName));
}

function getInput(el) {
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error('v-money requires 1 input, found ' + els.length);
    } else {
      el = els[0];
    }
  }
  return el;
}

function bind(el) {
  el = getInput(el);

  el.addEventListener('input', run(el, 'input'));
  el.addEventListener('change', run(el, 'change'));

  run(el, 'input');
}

function componentUpdated(el, binding, vnode, oldVnode) {
  // Prevent firing endless events
  if (vnode.data.model && vnode.data.model.value === oldVnode.data.model.value) {
    return;
  }

  el = getInput(el);
  el.value = vnode.data.model ? vnode.data.model.value : el.value;
  run(el, 'input');
}

/* harmony default export */ __webpack_exports__["a"] = ({ bind: bind, componentUpdated: componentUpdated });

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function toStr(value) {
  return value ? value.toString() : '';
}

function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || '0';
}

function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

function fixed(precision) {
  return between(0, precision, 20);
}

function numbersToCurrency(numbers, precision) {
  var exp = Math.pow(10, precision);
  var float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1' + separator);
}

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function format() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var opt = arguments[1];

  var value = typeof input === 'number' ? input.toFixed(fixed(opt.precision)) : input || '0';
  var numbers = onlyNumbers(value);
  var currency = numbersToCurrency(numbers, opt.precision);
  var parts = toStr(currency).split('.');

  var _parts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(parts, 2),
      integerDirty = _parts[0],
      decimal = _parts[1];

  var integer = addThousandSeparator(integerDirty, opt.thousands);
  return [opt.prefix, joinIntegerAndDecimal(integer, decimal, opt.decimal)].join('');
}

function setCursor(el, position) {
  function setSelectionRange() {
    el.setSelectionRange(position, position);
  }
  if (el === document.activeElement) {
    setSelectionRange();
    setTimeout(setSelectionRange, 1); // Android Fix
  }
}



/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2330d06a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__(243);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2330d06a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Clientes")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo cliente")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),(_vm.seleccionar === undefined || _vm.seleccionar === false)?_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.seleccionar === true)?_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.enviarRegistro(props.item)}}},[_vm._v("\n          check_box_outline_black\n        ")])],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("No data")])],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%"},model:{value:(_vm.ventanaRegistro),callback:function ($$v) {_vm.ventanaRegistro=$$v},expression:"ventanaRegistro"}},[_c('cliente',{attrs:{"ubigeo":_vm.ubigeo,"idRegistro":_vm.idClienteActual},on:{"cerrar":_vm.cerrarRegistro,"listar":_vm.listar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Comprobantes emitidos")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),(_vm.sinEmitir > 0)?_c('span',{staticClass:"red--text text--lighten-1"},[_vm._v("Comprobantes sin emitir("+_vm._s(_vm.sinEmitir)+")")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Emitir comprobante")])],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs1":"","sm1":"","lg1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Serie"},model:{value:(_vm.filtro.serie),callback:function ($$v) {_vm.$set(_vm.filtro, "serie", $$v)},expression:"filtro.serie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","lg2":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"#######"},model:{value:(_vm.filtro.numero),callback:function ($$v) {_vm.$set(_vm.filtro, "numero", $$v)},expression:"filtro.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","lg4":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.estadosComprobante,"item-text":"value","item-value":"id","label":"Estado"},model:{value:(_vm.filtro.estado),callback:function ($$v) {_vm.$set(_vm.filtro, "estado", $$v)},expression:"filtro.estado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","lg1":"","d-flex":""}},[_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.listarFiltro()}}},[_vm._v("Filtrar")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[((props.item.fila[5] === 'Rechazado'))?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Rechazado")]):_vm._e(),_vm._v(" "),((props.item.fila[5] === 'Sin emitir'))?_c('div',{staticStyle:{"color":"orange"}},[_vm._v("Sin emitir")]):_vm._e(),_vm._v(" "),((props.item.fila[5] === 'Aceptado'))?_c('div',{staticStyle:{"color":"green"}},[_vm._v("Aceptado")]):_vm._e(),_vm._v(" "),((props.item.fila[5] === 'Anulado'))?_c('div',{staticStyle:{"color":"blue"}},[_vm._v("Anulado")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.imprimirRegistro(props.item)}}},[_vm._v("\n          print\n        ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.descargarRegistro(props.item)}}},[_vm._v("\n          cloud_download\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("No data")])],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%"},model:{value:(_vm.ventanaRegistro),callback:function ($$v) {_vm.ventanaRegistro=$$v},expression:"ventanaRegistro"}},[_c('comprobante',{attrs:{"ubigeo":_vm.ubigeo,"idRegistro":_vm.idComprobanteActual,"idCliente":_vm.idCliente},on:{"cerrar":_vm.cerrarRegistro,"listar":_vm.listar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compras_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f3ec41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compras_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compras_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f3ec41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compras_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Gastos")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoComprobante()}}},[_vm._v("Ingresar gasto")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Gasto")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Serie","readonly":_vm.disabledComprobante},model:{value:(_vm.comprobante.gastoSerie),callback:function ($$v) {_vm.$set(_vm.comprobante, "gastoSerie", $$v)},expression:"comprobante.gastoSerie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"####################","messages":_vm.errores.gastoNumero.mensajes,"error":_vm.errores.gastoNumero.error,"readonly":_vm.disabledComprobante},model:{value:(_vm.comprobante.gastoNumero),callback:function ($$v) {_vm.$set(_vm.comprobante, "gastoNumero", $$v)},expression:"comprobante.gastoNumero"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm3":"","lg3":"","d-flex":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.comprobante.gastoFecha,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.comprobante, "gastoFecha", $event)},"update:return-value":function($event){return _vm.$set(_vm.comprobante, "gastoFecha", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","messages":_vm.errores.gastoFecha.mensajes,"error":_vm.errores.gastoFecha.error,"readonly":""},on:{"blur":function($event){_vm.comprobante.gastoFecha = _vm.parseDate(_vm.gastoFecha)}},slot:"activator",model:{value:(_vm.gastoFecha),callback:function ($$v) {_vm.gastoFecha=$$v},expression:"gastoFecha"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","scrollable":"","readonly":_vm.disabledComprobante},on:{"input":function($event){return _vm.$refs.menu.save(_vm.comprobante.gastoFecha)}},model:{value:(_vm.comprobante.gastoFecha),callback:function ($$v) {_vm.$set(_vm.comprobante, "gastoFecha", $$v)},expression:"comprobante.gastoFecha"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.comprobante.gastoDetalles),function(detalle,id){return _c('v-flex',{key:id,attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Detalle","readonly":_vm.disabledComprobante},on:{"keyup":function($event){detalle.gastoDescripcion = detalle.gastoDescripcion.toUpperCase();}},model:{value:(detalle.gastoDescripcion),callback:function ($$v) {_vm.$set(detalle, "gastoDescripcion", $$v)},expression:"detalle.gastoDescripcion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":"","offset-xs1":"","d-flex":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto","readonly":_vm.disabledComprobante},model:{value:(detalle.gastoMonto),callback:function ($$v) {_vm.$set(detalle, "gastoMonto", $$v)},expression:"detalle.gastoMonto"}})],1)],1)}),1),_vm._v(" "),_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","small":"","color":"pink"},on:{"click":_vm.detalleNuevo}},[_c('v-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Total","value":_vm.registroTotal,"maxlenght":"20","messages":_vm.errores.gastoTotal.mensajes,"error":_vm.errores.gastoTotal.error,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledComprobante)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.comprobante.gastoId)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalComprobantes,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verComprobante(props.item)}}},[_vm._v("\n          open_in_browser\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Depositos_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b40e169_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Depositos_vue__ = __webpack_require__(253);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Depositos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b40e169_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Depositos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Depósitos")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Ingresar depósito")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Depósito")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.registro.depositoFecha,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.registro, "depositoFecha", $event)},"update:return-value":function($event){return _vm.$set(_vm.registro, "depositoFecha", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","messages":_vm.errores.depositoFecha.mensajes,"error":_vm.errores.depositoFecha.error,"readonly":""},on:{"blur":function($event){_vm.registro.depositoFecha = _vm.parseDate(_vm.depositoFecha)}},slot:"activator",model:{value:(_vm.depositoFecha),callback:function ($$v) {_vm.depositoFecha=$$v},expression:"depositoFecha"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","readonly":_vm.disabledRegistro,"scrollable":""},on:{"input":function($event){return _vm.$refs.menu.save(_vm.registro.depositoFecha)}},model:{value:(_vm.registro.depositoFecha),callback:function ($$v) {_vm.$set(_vm.registro, "depositoFecha", $$v)},expression:"registro.depositoFecha"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"####################","messages":_vm.errores.depositoNumero.mensajes,"error":_vm.errores.depositoNumero.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.depositoNumero),callback:function ($$v) {_vm.$set(_vm.registro, "depositoNumero", $$v)},expression:"registro.depositoNumero"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Total","maxlenght":"20","messages":_vm.errores.depositoMonto.mensajes,"error":_vm.errores.depositoMonto.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.depositoMonto),callback:function ($$v) {_vm.$set(_vm.registro, "depositoMonto", $$v)},expression:"registro.depositoMonto"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.registro.registroId)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReporteVentas_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9a55e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReporteVentas_vue__ = __webpack_require__(256);
function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReporteVentas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9a55e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReporteVentas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Reportes")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}})],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-menu',{ref:"menuFechaInicio",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.registro.fechaInicio,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.registro, "fechaInicio", $event)},"update:return-value":function($event){return _vm.$set(_vm.registro, "fechaInicio", $event)}},model:{value:(_vm.menuFechaInicio),callback:function ($$v) {_vm.menuFechaInicio=$$v},expression:"menuFechaInicio"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","readonly":""},on:{"blur":function($event){_vm.registro.fechaInicio = _vm.parseDate(_vm.fechaInicio)}},slot:"activator",model:{value:(_vm.fechaInicio),callback:function ($$v) {_vm.fechaInicio=$$v},expression:"fechaInicio"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","readonly":_vm.disabledRegistro,"scrollable":""},on:{"input":function($event){return _vm.$refs.menuFechaInicio.save(_vm.registro.fechaInicio)}},model:{value:(_vm.registro.fechaInicio),callback:function ($$v) {_vm.$set(_vm.registro, "fechaInicio", $$v)},expression:"registro.fechaInicio"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":""}},[_c('v-menu',{ref:"menuFechaFin",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.registro.fechaFin,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.registro, "fechaFin", $event)},"update:return-value":function($event){return _vm.$set(_vm.registro, "fechaFin", $event)}},model:{value:(_vm.menuFechaFin),callback:function ($$v) {_vm.menuFechaFin=$$v},expression:"menuFechaFin"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","readonly":""},on:{"blur":function($event){_vm.registro.fechaFin = _vm.parseDate(_vm.fechaFin)}},slot:"activator",model:{value:(_vm.fechaFin),callback:function ($$v) {_vm.fechaFin=$$v},expression:"fechaFin"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","readonly":_vm.disabledRegistro,"scrollable":""},on:{"input":function($event){return _vm.$refs.menuFechaFin.save(_vm.registro.fechaFin)}},model:{value:(_vm.registro.fechaFin),callback:function ($$v) {_vm.$set(_vm.registro, "fechaFin", $$v)},expression:"registro.fechaFin"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-select',{attrs:{"readonly":_vm.disabledRegistro,"items":_vm.reportes,"item-text":"value","item-value":"id","label":"Tipo de reporte"},model:{value:(_vm.registro.tipoReporte),callback:function ($$v) {_vm.$set(_vm.registro, "tipoReporte", $$v)},expression:"registro.tipoReporte"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.generar($event)}}},[_vm._v("Generar")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogoLista_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4e50b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogoLista_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogoLista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e4e50b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogoLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Catálogo")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),(_vm.seleccionar === undefined || _vm.seleccionar === false)?_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.seleccionar === true)?_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.enviarRegistro(props.item)}}},[_vm._v("\n          check_box_outline_black\n        ")])],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("No data")])],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%"},model:{value:(_vm.ventanaRegistro),callback:function ($$v) {_vm.ventanaRegistro=$$v},expression:"ventanaRegistro"}},[_c('catalogo',{attrs:{"ubigeo":_vm.ubigeo,"idRegistro":_vm.idCatalogoActual},on:{"cerrar":_vm.cerrarRegistro,"listar":_vm.listar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 66,
	"./af.js": 66,
	"./ar": 67,
	"./ar-dz": 68,
	"./ar-dz.js": 68,
	"./ar-kw": 69,
	"./ar-kw.js": 69,
	"./ar-ly": 70,
	"./ar-ly.js": 70,
	"./ar-ma": 71,
	"./ar-ma.js": 71,
	"./ar-sa": 72,
	"./ar-sa.js": 72,
	"./ar-tn": 73,
	"./ar-tn.js": 73,
	"./ar.js": 67,
	"./az": 74,
	"./az.js": 74,
	"./be": 75,
	"./be.js": 75,
	"./bg": 76,
	"./bg.js": 76,
	"./bm": 77,
	"./bm.js": 77,
	"./bn": 78,
	"./bn.js": 78,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 87,
	"./de-at": 88,
	"./de-at.js": 88,
	"./de-ch": 89,
	"./de-ch.js": 89,
	"./de.js": 87,
	"./dv": 90,
	"./dv.js": 90,
	"./el": 91,
	"./el.js": 91,
	"./en-SG": 92,
	"./en-SG.js": 92,
	"./en-au": 93,
	"./en-au.js": 93,
	"./en-ca": 94,
	"./en-ca.js": 94,
	"./en-gb": 95,
	"./en-gb.js": 95,
	"./en-ie": 96,
	"./en-ie.js": 96,
	"./en-il": 97,
	"./en-il.js": 97,
	"./en-nz": 98,
	"./en-nz.js": 98,
	"./eo": 99,
	"./eo.js": 99,
	"./es": 100,
	"./es-do": 101,
	"./es-do.js": 101,
	"./es-us": 102,
	"./es-us.js": 102,
	"./es.js": 100,
	"./et": 103,
	"./et.js": 103,
	"./eu": 104,
	"./eu.js": 104,
	"./fa": 105,
	"./fa.js": 105,
	"./fi": 106,
	"./fi.js": 106,
	"./fo": 107,
	"./fo.js": 107,
	"./fr": 108,
	"./fr-ca": 109,
	"./fr-ca.js": 109,
	"./fr-ch": 110,
	"./fr-ch.js": 110,
	"./fr.js": 108,
	"./fy": 111,
	"./fy.js": 111,
	"./ga": 112,
	"./ga.js": 112,
	"./gd": 113,
	"./gd.js": 113,
	"./gl": 114,
	"./gl.js": 114,
	"./gom-latn": 115,
	"./gom-latn.js": 115,
	"./gu": 116,
	"./gu.js": 116,
	"./he": 117,
	"./he.js": 117,
	"./hi": 118,
	"./hi.js": 118,
	"./hr": 119,
	"./hr.js": 119,
	"./hu": 120,
	"./hu.js": 120,
	"./hy-am": 121,
	"./hy-am.js": 121,
	"./id": 122,
	"./id.js": 122,
	"./is": 123,
	"./is.js": 123,
	"./it": 124,
	"./it-ch": 125,
	"./it-ch.js": 125,
	"./it.js": 124,
	"./ja": 126,
	"./ja.js": 126,
	"./jv": 127,
	"./jv.js": 127,
	"./ka": 128,
	"./ka.js": 128,
	"./kk": 129,
	"./kk.js": 129,
	"./km": 130,
	"./km.js": 130,
	"./kn": 131,
	"./kn.js": 131,
	"./ko": 132,
	"./ko.js": 132,
	"./ku": 133,
	"./ku.js": 133,
	"./ky": 134,
	"./ky.js": 134,
	"./lb": 135,
	"./lb.js": 135,
	"./lo": 136,
	"./lo.js": 136,
	"./lt": 137,
	"./lt.js": 137,
	"./lv": 138,
	"./lv.js": 138,
	"./me": 139,
	"./me.js": 139,
	"./mi": 140,
	"./mi.js": 140,
	"./mk": 141,
	"./mk.js": 141,
	"./ml": 142,
	"./ml.js": 142,
	"./mn": 143,
	"./mn.js": 143,
	"./mr": 144,
	"./mr.js": 144,
	"./ms": 145,
	"./ms-my": 146,
	"./ms-my.js": 146,
	"./ms.js": 145,
	"./mt": 147,
	"./mt.js": 147,
	"./my": 148,
	"./my.js": 148,
	"./nb": 149,
	"./nb.js": 149,
	"./ne": 150,
	"./ne.js": 150,
	"./nl": 151,
	"./nl-be": 152,
	"./nl-be.js": 152,
	"./nl.js": 151,
	"./nn": 153,
	"./nn.js": 153,
	"./pa-in": 154,
	"./pa-in.js": 154,
	"./pl": 155,
	"./pl.js": 155,
	"./pt": 156,
	"./pt-br": 157,
	"./pt-br.js": 157,
	"./pt.js": 156,
	"./ro": 158,
	"./ro.js": 158,
	"./ru": 159,
	"./ru.js": 159,
	"./sd": 160,
	"./sd.js": 160,
	"./se": 161,
	"./se.js": 161,
	"./si": 162,
	"./si.js": 162,
	"./sk": 163,
	"./sk.js": 163,
	"./sl": 164,
	"./sl.js": 164,
	"./sq": 165,
	"./sq.js": 165,
	"./sr": 166,
	"./sr-cyrl": 167,
	"./sr-cyrl.js": 167,
	"./sr.js": 166,
	"./ss": 168,
	"./ss.js": 168,
	"./sv": 169,
	"./sv.js": 169,
	"./sw": 170,
	"./sw.js": 170,
	"./ta": 171,
	"./ta.js": 171,
	"./te": 172,
	"./te.js": 172,
	"./tet": 173,
	"./tet.js": 173,
	"./tg": 174,
	"./tg.js": 174,
	"./th": 175,
	"./th.js": 175,
	"./tl-ph": 176,
	"./tl-ph.js": 176,
	"./tlh": 177,
	"./tlh.js": 177,
	"./tr": 178,
	"./tr.js": 178,
	"./tzl": 179,
	"./tzl.js": 179,
	"./tzm": 180,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 180,
	"./ug-cn": 182,
	"./ug-cn.js": 182,
	"./uk": 183,
	"./uk.js": 183,
	"./ur": 184,
	"./ur.js": 184,
	"./uz": 185,
	"./uz-latn": 186,
	"./uz-latn.js": 186,
	"./uz.js": 185,
	"./vi": 187,
	"./vi.js": 187,
	"./x-pseudo": 188,
	"./x-pseudo.js": 188,
	"./yo": 189,
	"./yo.js": 189,
	"./zh-cn": 190,
	"./zh-cn.js": 190,
	"./zh-hk": 191,
	"./zh-hk.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Guía de Remisión")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.tiposDocumentos,"item-text":"value","item-value":"id","label":"Documento de identidad","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteTipoDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteTipoDocumento", $$v)},expression:"registro.comprobanteTipoDocumento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número documento","mask":"###########","readonly":_vm.disabledRegistro},on:{"keyup":function($event){return _vm.consultarRuc()}},model:{value:(_vm.registro.comprobanteNumeroDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteNumeroDocumento", $$v)},expression:"registro.comprobanteNumeroDocumento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[(!_vm.disabledRegistro && _vm.seleccionarClienteActivo)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.buscarCliente()}}},[_vm._v("Buscar cliente")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm3":"","lg3":"","d-flex":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.registro.comprobanteFecha,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.registro, "comprobanteFecha", $event)},"update:return-value":function($event){return _vm.$set(_vm.registro, "comprobanteFecha", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","messages":_vm.errores.comprobanteFecha.mensajes,"error":_vm.errores.comprobanteFecha.error,"readonly":""},on:{"blur":function($event){_vm.registro.comprobanteFecha = _vm.parseDate(_vm.comprobanteFecha)}},slot:"activator",model:{value:(_vm.comprobanteFecha),callback:function ($$v) {_vm.comprobanteFecha=$$v},expression:"comprobanteFecha"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","scrollable":"","readonly":_vm.disabledRegistro},on:{"input":function($event){return _vm.$refs.menu.save(_vm.registro.comprobanteFecha)}},model:{value:(_vm.registro.comprobanteFecha),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteFecha", $$v)},expression:"registro.comprobanteFecha"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":"","lg2":""}},[_c('v-text-field',{attrs:{"label":"Hora","mask":"time","messages":_vm.errores.comprobanteHora.mensajes,"error":_vm.errores.comprobanteHora.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteHora),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteHora", $$v)},expression:"registro.comprobanteHora"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Cliente","maxlenght":"50","messages":_vm.errores.comprobanteCliente.mensajes,"error":_vm.errores.comprobanteCliente.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.comprobanteCliente = _vm.registro.comprobanteCliente.toUpperCase();}},model:{value:(_vm.registro.comprobanteCliente),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteCliente", $$v)},expression:"registro.comprobanteCliente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg10":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Dirección","maxlenght":"50","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.comprobanteDireccion = _vm.registro.comprobanteDireccion.toUpperCase();}},model:{value:(_vm.registro.comprobanteDireccion),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteDireccion", $$v)},expression:"registro.comprobanteDireccion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","lg2":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.ubigeo,"item-text":"nombre","item-value":"id","hide-no-data":"","hide-details":"","label":"Ubigeo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteUbigeo),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteUbigeo", $$v)},expression:"registro.comprobanteUbigeo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":"","lg2":"","d-flex":""}},[_c('v-select',{attrs:{"readonly":_vm.disabledRegistro,"items":_vm.seriesCombo,"item-text":"value","item-value":"id","label":"Serie"},model:{value:(_vm.registro.comprobanteSerie),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteSerie", $$v)},expression:"registro.comprobanteSerie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm3":"","lg1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"#######","messages":_vm.errores.comprobanteNumero.mensajes,"error":_vm.errores.comprobanteNumero.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteNumero),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteNumero", $$v)},expression:"registro.comprobanteNumero"}})],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.registro.comprobanteDetalles),function(detalle,id){return _c('v-flex',{key:id,attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-flex',{attrs:{"xs3":"","sm2":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.productosCodigos,"item-text":"nombre","item-value":"id","hide-no-data":"","hide-details":"","label":"Código de producto","readonly":_vm.disabledRegistro},on:{"change":function($event){return _vm.escogerProducto(detalle)}},model:{value:(detalle.producto),callback:function ($$v) {_vm.$set(detalle, "producto", $$v)},expression:"detalle.producto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Cantidad","readonly":_vm.disabledRegistro},model:{value:(detalle.cantidad),callback:function ($$v) {_vm.$set(detalle, "cantidad", $$v)},expression:"detalle.cantidad"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Unidad","readonly":_vm.disabledRegistro},model:{value:(detalle.unidadMedida),callback:function ($$v) {_vm.$set(detalle, "unidadMedida", $$v)},expression:"detalle.unidadMedida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm6":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Detalle","readonly":_vm.disabledRegistro},on:{"keyup":function($event){detalle.descripcion = detalle.descripcion.toUpperCase();}},model:{value:(detalle.descripcion),callback:function ($$v) {_vm.$set(detalle, "descripcion", $$v)},expression:"detalle.descripcion"}})],1)],1)}),1),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","small":"","color":"pink"},on:{"click":_vm.detalleNuevo}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.modalidadesTraslado,"item-text":"value","item-value":"id","label":"Modalidad de traslado","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.modalidadTraslado),callback:function ($$v) {_vm.$set(_vm.registro, "modalidadTraslado", $$v)},expression:"registro.modalidadTraslado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.indicadoresTransbordo,"item-text":"value","item-value":"id","label":"Indicador de transbordo programado","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.indicadorTransbordo),callback:function ($$v) {_vm.$set(_vm.registro, "indicadorTransbordo", $$v)},expression:"registro.indicadorTransbordo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.indicadoresVehiculo,"item-text":"value","item-value":"id","label":"Indicador de traslado en vehículos M1/L","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.indicadorVehiculoM1L),callback:function ($$v) {_vm.$set(_vm.registro, "indicadorVehiculoM1L", $$v)},expression:"registro.indicadorVehiculoM1L"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Placa de vehículo","maxlength":"10","readonly":_vm.disabledRegistro,"messages":_vm.errores.placaVehiculo.mensajes,"error":_vm.errores.placaVehiculo.error},on:{"input":function($event){_vm.registro.placaVehiculo = _vm.registro.placaVehiculo.toUpperCase()}},model:{value:(_vm.registro.placaVehiculo),callback:function ($$v) {_vm.$set(_vm.registro, "placaVehiculo", $$v)},expression:"registro.placaVehiculo"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '' && _vm.diasEmision > 7)?_c('div',{staticStyle:{"color":"red","margin-right":"20px"}},[_c('b',[_vm._v("Fecha de emisión superior a 7 días, puede ser rechazada por SUNAT")])]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '')?_c('v-btn',{attrs:{"color":_vm.colorEmitir,"dark":""},nativeOn:{"click":function($event){return _vm.emitir(_vm.registro.comprobanteId)}}},[_vm._v("Emitir")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '')?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.editar(_vm.registro.comprobanteId)}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.registro.comprobanteId)}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && !_vm.anularRegistro && _vm.registro.comprobanteEstado !== '')?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.imprimirRegistro({fila: [_vm.registro.comprobanteId]})}}},[_vm._v("Imprimir")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && !_vm.anularRegistro && _vm.puedeAnular)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.confirmarAnular(_vm.registro.comprobanteId)}}},[_vm._v("Anular")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar guía")]),_vm._v(" "),(_vm.disabledRegistro && _vm.anularRegistro && _vm.puedeAnular)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.anular(_vm.registro.comprobanteId)}}},[_vm._v("Confirmar anular")]):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%"},model:{value:(_vm.ventanaCliente),callback:function ($$v) {_vm.ventanaCliente=$$v},expression:"ventanaCliente"}},[_c('v-card',[_c('clientes-lista',{attrs:{"seleccionar":true},on:{"seleccionado":_vm.seleccionarCliente}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Guías de Remisión emitidas")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),(_vm.sinEmitir > 0)?_c('span',{staticClass:"red--text text--lighten-1"},[_vm._v("Guías sin emitir("+_vm._s(_vm.sinEmitir)+")")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Emitir guía")])],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs1":"","sm1":"","lg1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Serie"},model:{value:(_vm.filtro.serie),callback:function ($$v) {_vm.$set(_vm.filtro, "serie", $$v)},expression:"filtro.serie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","lg2":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"#######"},model:{value:(_vm.filtro.numero),callback:function ($$v) {_vm.$set(_vm.filtro, "numero", $$v)},expression:"filtro.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","lg4":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.estadosGuia,"item-text":"value","item-value":"id","label":"Estado"},model:{value:(_vm.filtro.estado),callback:function ($$v) {_vm.$set(_vm.filtro, "estado", $$v)},expression:"filtro.estado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","lg1":"","d-flex":""}},[_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.listarFiltro()}}},[_vm._v("Filtrar")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[((props.item.fila[4] === 'Rechazado'))?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Rechazado")]):_vm._e(),_vm._v(" "),((props.item.fila[4] === 'Sin emitir'))?_c('div',{staticStyle:{"color":"orange"}},[_vm._v("Sin emitir")]):_vm._e(),_vm._v(" "),((props.item.fila[4] === 'Aceptado'))?_c('div',{staticStyle:{"color":"green"}},[_vm._v("Aceptado")]):_vm._e(),_vm._v(" "),((props.item.fila[4] === 'Anulado'))?_c('div',{staticStyle:{"color":"blue"}},[_vm._v("Anulado")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.imprimirRegistro(props.item)}}},[_vm._v("\n          print\n        ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.descargarRegistro(props.item)}}},[_vm._v("\n          cloud_download\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("No data")])],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%"},model:{value:(_vm.ventanaRegistro),callback:function ($$v) {_vm.ventanaRegistro=$$v},expression:"ventanaRegistro"}},[_c('guia-remision',{attrs:{"ubigeo":_vm.ubigeo,"idRegistro":_vm.idGuiaActual,"idCliente":_vm.idCliente},on:{"cerrar":_vm.cerrarRegistro,"listar":_vm.listar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(193);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c1a5d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(286);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c1a5d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500px","persistent":""},model:{value:(_vm.login.open),callback:function ($$v) {_vm.$set(_vm.login, "open", $$v)},expression:"login.open"}},[_c('v-card',[_c('v-card-title',{staticClass:"grey lighten-4 py-4 title"},[_vm._v("\n      Ingresar\n    ")]),_vm._v(" "),_c('v-container',{staticClass:"pa-4",attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.msgError)+" "+_vm._s(_vm.mensaje))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Usuario","type":"text"},model:{value:(_vm.usuario),callback:function ($$v) {_vm.usuario=$$v},expression:"usuario"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Clave","type":"password"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loginIngresar($event)}},model:{value:(_vm.clave),callback:function ($$v) {_vm.clave=$$v},expression:"clave"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.loginIngresar}},[_vm._v("Ingresar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CambiarClave_vue__ = __webpack_require__(194);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a6e3e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CambiarClave_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CambiarClave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a6e3e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CambiarClave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500px"},model:{value:(_vm.cambiarClave.open),callback:function ($$v) {_vm.$set(_vm.cambiarClave, "open", $$v)},expression:"cambiarClave.open"}},[_c('v-card',[_c('v-card-title',{staticClass:"grey lighten-4 py-4 title"},[_vm._v("\n      Cambiar clave\n    ")]),_vm._v(" "),_c('v-container',{staticClass:"pa-4",attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Clave actual","type":"password"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Nueva clave","type":"password"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Repetir nueva clave","type":"password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.cambiarClave.open = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cambiarClave.open = false}}},[_vm._v("Guardar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaProducto_vue__ = __webpack_require__(195);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f985257c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaProducto_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaProducto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f985257c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaProducto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"producto",attrs:{"d-flex":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":_vm.producto.urlImg,"height":"100px","contain":""},on:{"click":function($event){return _vm.cambiarCantidad(1)},"contextmenu":function($event){$event.preventDefault();return _vm.cambiarCantidad(-1)}}},[_c('v-container',{attrs:{"fill-height":"","fluid":"","pa-2":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline white--text"})])],1)],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.producto.nombre))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-chip',{attrs:{"color":_vm.colorFondo,"text-color":_vm.colorTexto}},[_vm._v(_vm._s(_vm.producto.cantidad))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!this.disabled)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.cambiarCantidad(1)}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(!this.disabled)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.cambiarCantidad(-1)}}},[_c('v-icon',[_vm._v("remove_circle")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{attrs:{"color":_vm.colorFondo,"text-color":_vm.colorTexto}},[_vm._v(_vm._s(_vm.producto.moneda)+_vm._s(_vm._f("formatoNumero")(_vm.total)))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaSeleccionarProducto_vue__ = __webpack_require__(196);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43316b32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaSeleccionarProducto_vue__ = __webpack_require__(293);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaSeleccionarProducto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43316b32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaSeleccionarProducto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((this.productos),function(producto,id){return _c('venta-producto',{key:id,attrs:{"producto":producto,"disabled":_vm.disabled},on:{"cambio-total":function($event){return _vm.calcularTotal()}}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaManual_vue__ = __webpack_require__(197);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a508acf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaManual_vue__ = __webpack_require__(295);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VentaManual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a508acf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VentaManual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.comprobante.gastoDetalles),function(detalle,id){return _c('v-flex',{key:id,attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Detalle","readonly":_vm.disabledComprobante},model:{value:(detalle.gastoDescripcion),callback:function ($$v) {_vm.$set(detalle, "gastoDescripcion", $$v)},expression:"detalle.gastoDescripcion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":"","offset-xs1":"","d-flex":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto","readonly":_vm.disabledComprobante},model:{value:(detalle.gastoMonto),callback:function ($$v) {_vm.$set(detalle, "gastoMonto", $$v)},expression:"detalle.gastoMonto"}})],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cliente_vue__ = __webpack_require__(198);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e5fab0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cliente_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e5fab0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cliente")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","d-flex":""}},[_c('v-select',{attrs:{"readonly":_vm.disabledRegistro,"items":_vm.tiposDocumentos,"item-text":"value","item-value":"id","label":"Documento de identidad","messages":_vm.errores.clienteTipoDocumento.mensajes,"error":_vm.errores.clienteTipoDocumento.error},model:{value:(_vm.registro.clienteTipoDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "clienteTipoDocumento", $$v)},expression:"registro.clienteTipoDocumento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número documento","mask":"###########","messages":_vm.errores.clienteNumeroDocumento.mensajes,"error":_vm.errores.clienteNumeroDocumento.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clienteNumeroDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "clienteNumeroDocumento", $$v)},expression:"registro.clienteNumeroDocumento"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm3":"","lg3":"","d-flex":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":"","lg2":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Cliente","maxlenght":"50","messages":_vm.errores.clienteRazonSocial.mensajes,"error":_vm.errores.clienteRazonSocial.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.clienteRazonSocial = _vm.registro.clienteRazonSocial.toUpperCase();}},model:{value:(_vm.registro.clienteRazonSocial),callback:function ($$v) {_vm.$set(_vm.registro, "clienteRazonSocial", $$v)},expression:"registro.clienteRazonSocial"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","lg12":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Dirección","maxlenght":"50","messages":_vm.errores.clienteDireccion.mensajes,"error":_vm.errores.clienteDireccion.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.clienteDireccion = _vm.registro.clienteDireccion.toUpperCase();}},model:{value:(_vm.registro.clienteDireccion),callback:function ($$v) {_vm.$set(_vm.registro, "clienteDireccion", $$v)},expression:"registro.clienteDireccion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg4":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.ubigeo,"item-text":"nombre","item-value":"id","messages":_vm.errores.clienteUbigeo.mensajes,"error":_vm.errores.clienteUbigeo.error,"hide-no-data":"","hide-details":"","label":"Ubigeo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clienteUbigeo),callback:function ($$v) {_vm.$set(_vm.registro, "clienteUbigeo", $$v)},expression:"registro.clienteUbigeo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.eliminarRegistro)?_c('div',[_c('div',[_vm._v("¿Seguro que desea eliminar este registro?")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.borrar(_vm.registro.clienteId)}}},[_vm._v("Eliminar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cancelar($event)}}},[_vm._v("Cancelar")])],1):_vm._e(),_vm._v(" "),(!_vm.eliminarRegistro)?_c('div',[(_vm.disabledRegistro && !_vm.eliminarRegistro)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.confirmarEliminar($event)}}},[_vm._v("Eliminar")]):_vm._e(),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.registro.clienteId)}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.editar($event)}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")])],1):_vm._e()],1),_vm._v(" "),_c('br')],1),_vm._v(" "),(_vm.disabledRegistro)?_c('v-card',[_c('br'),_vm._v(" "),_c('comprobantes-lista',{attrs:{"ubigeo":_vm.ubigeo,"idCliente":_vm.registro.clienteId}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comprobante_vue__ = __webpack_require__(199);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d63d1f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comprobante_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comprobante_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d63d1f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comprobante_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Comprobante")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.tiposDocumentos,"item-text":"value","item-value":"id","label":"Documento de identidad","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteTipoDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteTipoDocumento", $$v)},expression:"registro.comprobanteTipoDocumento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número documento","mask":"###########","readonly":_vm.disabledRegistro},on:{"keyup":function($event){return _vm.consultarDni()}},model:{value:(_vm.registro.comprobanteNumeroDocumento),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteNumeroDocumento", $$v)},expression:"registro.comprobanteNumeroDocumento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg3":"","d-flex":""}},[(!_vm.disabledRegistro && _vm.seleccionarClienteActivo)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.buscarCliente()}}},[_vm._v("Buscar cliente")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm3":"","lg3":"","d-flex":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.registro.comprobanteFecha,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.registro, "comprobanteFecha", $event)},"update:return-value":function($event){return _vm.$set(_vm.registro, "comprobanteFecha", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha","prepend-icon":"event","messages":_vm.errores.comprobanteFecha.mensajes,"error":_vm.errores.comprobanteFecha.error,"readonly":""},on:{"blur":function($event){_vm.registro.comprobanteFecha = _vm.parseDate(_vm.comprobanteFecha)}},slot:"activator",model:{value:(_vm.comprobanteFecha),callback:function ($$v) {_vm.comprobanteFecha=$$v},expression:"comprobanteFecha"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-pe","scrollable":"","readonly":_vm.disabledRegistro},on:{"input":function($event){return _vm.$refs.menu.save(_vm.registro.comprobanteFecha)}},model:{value:(_vm.registro.comprobanteFecha),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteFecha", $$v)},expression:"registro.comprobanteFecha"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":"","lg2":""}},[_c('v-text-field',{attrs:{"label":"Hora","mask":"time","messages":_vm.errores.comprobanteHora.mensajes,"error":_vm.errores.comprobanteHora.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteHora),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteHora", $$v)},expression:"registro.comprobanteHora"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Cliente","maxlenght":"50","messages":_vm.errores.comprobanteCliente.mensajes,"error":_vm.errores.comprobanteCliente.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.comprobanteCliente = _vm.registro.comprobanteCliente.toUpperCase();}},model:{value:(_vm.registro.comprobanteCliente),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteCliente", $$v)},expression:"registro.comprobanteCliente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg10":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Dirección","maxlenght":"50","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.comprobanteDireccion = _vm.registro.comprobanteDireccion.toUpperCase();}},model:{value:(_vm.registro.comprobanteDireccion),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteDireccion", $$v)},expression:"registro.comprobanteDireccion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","lg2":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.ubigeo,"item-text":"nombre","item-value":"id","hide-no-data":"","hide-details":"","label":"Ubigeo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteUbigeo),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteUbigeo", $$v)},expression:"registro.comprobanteUbigeo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":"","lg2":"","d-flex":""}},[_c('v-select',{attrs:{"readonly":_vm.disabledRegistro,"items":_vm.seriesCombo,"item-text":"value","item-value":"id","label":"Serie"},model:{value:(_vm.registro.comprobanteSerie),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteSerie", $$v)},expression:"registro.comprobanteSerie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm3":"","lg1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número","mask":"#######","messages":_vm.errores.comprobanteNumero.mensajes,"error":_vm.errores.comprobanteNumero.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.comprobanteNumero),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteNumero", $$v)},expression:"registro.comprobanteNumero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","lg6":"","d-flex":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":"","lg2":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Serie guía","messages":_vm.errores.guiaSerie.mensajes,"error":_vm.errores.guiaSerie.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.guiaSerie),callback:function ($$v) {_vm.$set(_vm.registro, "guiaSerie", $$v)},expression:"registro.guiaSerie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm3":"","lg1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número guía","mask":"#######","messages":_vm.errores.guiaNumero.mensajes,"error":_vm.errores.guiaNumero.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.guiaNumero),callback:function ($$v) {_vm.$set(_vm.registro, "guiaNumero", $$v)},expression:"registro.guiaNumero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","lg1":"","d-flex":""}},[(!_vm.disabledRegistro)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.importarGuia()}}},[_vm._v("Importar")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.registro.comprobanteDetalles),function(detalle,id){return _c('v-flex',{key:id,attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-flex',{attrs:{"xs3":"","sm2":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.productosCodigos,"item-text":"nombre","item-value":"id","hide-no-data":"","hide-details":"","label":"Código de producto","readonly":_vm.disabledRegistro},on:{"change":function($event){return _vm.escogerProducto(detalle)}},model:{value:(detalle.producto),callback:function ($$v) {_vm.$set(detalle, "producto", $$v)},expression:"detalle.producto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Cantidad","readonly":_vm.disabledRegistro},on:{"change":_vm.sumarTotal},model:{value:(detalle.cantidad),callback:function ($$v) {_vm.$set(detalle, "cantidad", $$v)},expression:"detalle.cantidad"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Unidad","readonly":_vm.disabledRegistro},model:{value:(detalle.unidadMedida),callback:function ($$v) {_vm.$set(detalle, "unidadMedida", $$v)},expression:"detalle.unidadMedida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm6":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Detalle","readonly":_vm.disabledRegistro},on:{"keyup":function($event){detalle.descripcion = detalle.descripcion.toUpperCase();}},model:{value:(detalle.descripcion),callback:function ($$v) {_vm.$set(detalle, "descripcion", $$v)},expression:"detalle.descripcion"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm1":"","d-flex":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"P. Unit.","readonly":_vm.disabledRegistro},on:{"change":_vm.sumarTotal},model:{value:(detalle.totalUnitario),callback:function ($$v) {_vm.$set(detalle, "totalUnitario", $$v)},expression:"detalle.totalUnitario"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm1":"","d-flex":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Total","readonly":_vm.disabledRegistro},on:{"change":_vm.sumarTotal},model:{value:(detalle.total),callback:function ($$v) {_vm.$set(detalle, "total", $$v)},expression:"detalle.total"}})],1)],1)}),1),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","small":"","color":"pink"},on:{"click":_vm.detalleNuevo}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":""}},[_c('v-checkbox',{attrs:{"readonly":_vm.disabledRegistro,"label":"Bienes transferidos en la amazonía"},model:{value:(_vm.registro.bienesAmazonia),callback:function ($$v) {_vm.$set(_vm.registro, "bienesAmazonia", $$v)},expression:"registro.bienesAmazonia"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"readonly":_vm.disabledRegistro,"label":"Servicios prestados en la amazonía"},model:{value:(_vm.registro.serviciosAmazonia),callback:function ($$v) {_vm.$set(_vm.registro, "serviciosAmazonia", $$v)},expression:"registro.serviciosAmazonia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":""}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Total","maxlenght":"20","messages":_vm.errores.comprobanteTotal.mensajes,"error":_vm.errores.comprobanteTotal.error,"readonly":""},model:{value:(_vm.registro.comprobanteTotal),callback:function ($$v) {_vm.$set(_vm.registro, "comprobanteTotal", $$v)},expression:"registro.comprobanteTotal"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '' && _vm.diasEmision > 7)?_c('div',{staticStyle:{"color":"red","margin-right":"20px"}},[_c('b',[_vm._v("Fecha de emisión superior a 7 días, puede ser rechazada por SUNAT")])]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '')?_c('v-btn',{attrs:{"color":_vm.colorEmitir,"dark":""},nativeOn:{"click":function($event){return _vm.emitir(_vm.registro.comprobanteId)}}},[_vm._v("Emitir")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && _vm.registro.comprobanteEstado === '')?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.editar(_vm.registro.comprobanteId)}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.registro.comprobanteId)}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && !_vm.anularRegistro && _vm.registro.comprobanteEstado !== '')?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.imprimirRegistro({fila: [_vm.registro.comprobanteId]})}}},[_vm._v("Imprimir")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && !_vm.anularRegistro && _vm.puedeAnular)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.confirmarAnular(_vm.registro.comprobanteId)}}},[_vm._v("Anular")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar comprobante")]),_vm._v(" "),(_vm.disabledRegistro && _vm.anularRegistro && _vm.puedeAnular)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.anular(_vm.registro.comprobanteId)}}},[_vm._v("Confirmar anular")]):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%"},model:{value:(_vm.ventanaCliente),callback:function ($$v) {_vm.ventanaCliente=$$v},expression:"ventanaCliente"}},[_c('v-card',[_c('clientes-lista',{attrs:{"seleccionar":true},on:{"seleccionado":_vm.seleccionarCliente}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalogo_vue__ = __webpack_require__(200);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c1e0ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Catalogo_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c1e0ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Catalogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Catálogo")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","lg12":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Artículo","messages":_vm.errores.catalogoArticulo.mensajes,"error":_vm.errores.catalogoArticulo.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.catalogoArticulo = _vm.registro.catalogoArticulo.toUpperCase();}},model:{value:(_vm.registro.catalogoArticulo),callback:function ($$v) {_vm.$set(_vm.registro, "catalogoArticulo", $$v)},expression:"registro.catalogoArticulo"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","lg4":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Unidad","messages":_vm.errores.catalogoUnidad.mensajes,"error":_vm.errores.catalogoUnidad.error,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.catalogoUnidad),callback:function ($$v) {_vm.$set(_vm.registro, "catalogoUnidad", $$v)},expression:"registro.catalogoUnidad"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg4":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Marca","messages":_vm.errores.catalogoMarca.mensajes,"error":_vm.errores.catalogoMarca.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.catalogoMarca = _vm.registro.catalogoMarca.toUpperCase();}},model:{value:(_vm.registro.catalogoMarca),callback:function ($$v) {_vm.$set(_vm.registro, "catalogoMarca", $$v)},expression:"registro.catalogoMarca"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","lg4":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Modelo","messages":_vm.errores.catalogoModelo.mensajes,"error":_vm.errores.catalogoModelo.error,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.catalogoModelo = _vm.registro.catalogoModelo.toUpperCase();}},model:{value:(_vm.registro.catalogoModelo),callback:function ($$v) {_vm.$set(_vm.registro, "catalogoModelo", $$v)},expression:"registro.catalogoModelo"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"success","dark":""},nativeOn:{"click":function($event){return _vm.guardar(_vm.registro.catalogoId)}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.editar($event)}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[201]);


// WEBPACK FOOTER //
// static/js/app.882e0224ab8f56c592b0.js